module.exports = __webpack_public_path__ + "c14e6ffb22f45bd0a16ba6604be2d0d9.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/811.png
// module id = 1714
// module chunks = 2